import Action from '../classes/Action';

type setterFunction<T> = (value: T) => void;

export default class SetValueAction<T> extends Action
{
	constructor(setterFuncs: setterFunction<T>[], newValues: T[], oldValues: T[], actionName: string, callbackEvent: string | null = null)
	{
		super([setterFuncs, newValues, callbackEvent], [setterFuncs, oldValues, callbackEvent], actionName, [setterFuncs, newValues, oldValues]);
	}

	do(setterFuncs: setterFunction<T>[], values: T[], callbackEvent: string | null) : void
	{
		for (let i = 0; i < setterFuncs.length; i++)
		{
			setterFuncs[i](values[i]);
		}

		if (callbackEvent)
		{
			document.dispatchEvent(new CustomEvent(callbackEvent));
		}
	}

	verify(setterFuncs: setterFunction<T>[], newValues: T[], oldValues: T[]) : boolean
	{
		if (setterFuncs.length !== newValues.length || setterFuncs.length !== oldValues.length)
		{
			return false;
		}

		for (let i = 0; i < setterFuncs.length; i++)
		{
			if (newValues[i] !== oldValues[i])
			{
				return true;
			}
		}

		return false;
	}
}
